import { lazy } from 'react';

export const ScheduleEventsPage = lazy(() => import('./ScheduleEventsPage'));
